export const StatusFlow = {
  Property: 1,
};